import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

const CheckMarkList = ({ children, className, items, ...otherProps }) => (
  <ul
    className={classnames('list list--checkmarks', className)}
    {...otherProps}
  >
    {children ||
      items.map((item, index) => <li key={`${item}#${index}`}>{item}</li>)}
  </ul>
);

CheckMarkList.defaultProps = {
  items: []
};

CheckMarkList.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string.isRequired)
};

export default CheckMarkList;
